import { Component, computed, input } from '@angular/core';
import { Ttm } from '../../../classes/ttm';

@Component({
  selector: 'app-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss'
})
export class StatusChipComponent {
    statusKey = input.required<string>();
    ttmStatuses = input.required<any[]>();

    textColor = computed(() => {
        return ['placed', 'turned_up'].includes(this.statusKey()) ? '#000000' : '#ffffff';
    });
}
